import template from './templates/menu-button-item.tpl.html';

function menuButtonItem(translateValueSupport) {
  return {
    restrict: 'E',
    require: ['^^akamMenuButton', '^^?akamSubmenu', 'akamMenuButtonItem'],
    replace: true,
    scope: true,
    bindToController: {
      text: '@',
      icon: '@?',
      isDisabled: '=?'
    },
    controller: () => {},
    controllerAs: 'menuButtonItem',
    link: (scope, elem, attr, [menuBtnCtrl, submenuCtrl, menuBtnItemCtrl]) => {
      if (menuBtnItemCtrl.icon) {
        if (submenuCtrl) {
          submenuCtrl.hasMenuItemIcons = true;
        } else {
          menuBtnCtrl.hasMenuItemIcons = true;
        }
      }
      translateValueSupport.setValues(scope.menuButtonItem, 'text', attr.textValues);
    },
    template
  };
}
menuButtonItem.$inject = ['translateValueSupport'];
export default menuButtonItem;
